import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AlbumCard } from "@/components/AlbumCard";
import TrackList from "@/components/TrackList";
import { Radio, Users } from "lucide-react";
import { Link } from "react-router-dom";

export default function FollowFeed() {
  const { user } = useAuth();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!user) return;
    api.get("/feed?limit=12").then((r) => setData(r.data)).catch(() => setData({ tracks: [], albums: [], artist_ids: [] }));
  }, [user]);

  if (!user || !data) return null;
  if (data.artist_ids?.length === 0) return null; // hide if user follows nobody

  return (
    <section data-testid="follow-feed" className="max-w-[1400px] mx-auto px-4 md:px-8 py-12 border-t border-[#2A2A2A]">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-[#FF4500] mb-2 flex items-center gap-2">
            <Users className="h-4 w-4" /> For you · from artists you follow
          </div>
          <h2 className="font-display font-bold text-3xl md:text-5xl tracking-tighter">Your drops.</h2>
        </div>
        <Link to="/browse" className="hidden sm:inline font-mono text-xs uppercase tracking-widest text-[#FF4500] hover:text-white transition-colors">
          Explore more →
        </Link>
      </div>

      {data.albums?.length > 0 && (
        <div className="mb-8">
          <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500 mb-3">Latest albums</div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-6">
            {data.albums.slice(0, 6).map((a) => <AlbumCard key={a.id} album={a} />)}
          </div>
        </div>
      )}

      {data.tracks?.length > 0 && (
        <div>
          <div className="font-mono text-[10px] uppercase tracking-widest text-gray-500 mb-3">Latest tracks</div>
          <TrackList tracks={data.tracks.slice(0, 8)} contextList={data.tracks} />
        </div>
      )}

      {data.tracks?.length === 0 && data.albums?.length === 0 && (
        <div className="p-8 text-center font-mono text-xs text-gray-500 uppercase tracking-widest border border-dashed border-[#2A2A2A] flex items-center justify-center gap-2">
          <Radio className="h-4 w-4" /> Followed artists haven&apos;t dropped anything new yet
        </div>
      )}
    </section>
  );
}
